import React, { useCallback, useEffect, useState } from 'react'
import { useSwiper, Swiper, SwiperSlide } from 'swiper/react'
import classNames from 'classnames'

import TextAndImageBlock from '@components/blocks/text_and_image_block'
import styles from '@components/blocks/text_and_image_carousel.module.scss'

const TextAndImageCarousel = React.forwardRef(({ fields }, _) => {
  const [blockIndex, setBlockIndex] = useState(0)

  const blocks = fields.content

  return (
    <div className={styles.text_and_image_carousel}>
      <h2 className={styles.text_and_image_carousel__title}>{fields.title}</h2>
      <div className={styles.text_and_image_carousel__carousel}>
        <Swiper onSlideChange={swiper => setBlockIndex(swiper.activeIndex)}>
          {blocks.map(block => (
            <SwiperSlide key={block.fields.title}>
              <TextAndImageBlock fields={block.fields} />
            </SwiperSlide>
          ))}
          <SlideIndicators blocks={blocks} blockIndex={blockIndex} setBlockIndex={setBlockIndex} />
        </Swiper>
      </div>
    </div>
  )
})

const SlideIndicators = ({ blocks, blockIndex, setBlockIndex }) => {
  const swiper = useSwiper()

  const blocksCount = blocks.length
  const [autoPlay, setAutoPlay] = useState(true)

  const setSlideIndex = index => {
    setBlockIndex(index)
    setAutoPlay(false)
    swiper.slideTo(index)
  }

  const advanceSlide = useCallback(() => {
    const newIndex = (blockIndex + 1) % blocksCount
    setBlockIndex(newIndex)
    swiper.slideTo(newIndex)
  }, [blockIndex, blocksCount, setBlockIndex, swiper])

  useEffect(() => {
    let timeout = null

    if (autoPlay) {
      timeout = setTimeout(advanceSlide, 10000)
    }

    return () => {
      clearTimeout(timeout)
    }
  }, [advanceSlide, autoPlay])

  return (
    <div className="slide_indicators">
      {blocks.map((_, index) => (
        <button
          key={index}
          className={classNames('slide_indicators__dot', {
            'slide_indicators__dot--active': index === blockIndex,
          })}
          onClick={() => setSlideIndex(index)}
          aria-label={`Slide ${index + 1}`}
        />
      ))}
    </div>
  )
}

export default TextAndImageCarousel
